import "jquery/dist/jquery.min.js";
import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
//import CheckFailures from '@/pages/vehicles/vehiclescheckfailures/vehiclescheckfailures.vue';
import BrakesCheck from '@/pages/vehicles/brakescheck/brakescheck.vue';
import VehicleDocuments from "@/pages/vehicles/vehicledocuments/vehicledocuments.vue";
import { CalendarView,CalendarViewHeader,CalendarMathMixin } from "vue-simple-calendar";
import Datepicker from "vuejs-datepicker";
import { replace } from "feather-icons";
import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
import VehicleTrips from '@/pages/vehicles/vehicletrips/vehicletrips.vue';
import { setTimeout } from "core-js";
import { confirmMileageThen, confirmSuspiciousMileage } from "@/utils/mileageValidation.js";
var moment = require("moment");

  export default {
    props: ["VehicleDetails","InspectionClasses"],
    components: {
      CalendarView,
      CalendarViewHeader,
      Datepicker,
      //CheckFailures, 
      BrakesCheck,    
      VehicleDocuments, 
      VehicleTrips,
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
      datetime: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY hh:mm A");
        }
        return sendDate;
      },
      region: function(data){
        return VehicleRegistrationRegion(data);
      }
    },
    data() {
      return {
        ViewDocument:{},
        trackingModule: false,      	
        format: "dd-MM-yyyy",
        VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
        PopupLoader: false,
        ShowLoader: false,
        submitted: false,
        mileageConfirmed: false,
        confirmedMileageValue: null,
        editForm:false,
        SaveData:false,
        UKVDSaveData:false,
        UKVDEditForm:false,
        ServiceSaveData:false,
        serviceEditForm:false,
        ShowDocuments:false,
        ShowViewDetailModel: false,
        ShowClassTooltip:false,
        VehicleId: 0,
        componentKey:0,
        Branches:{},
        VehicleClasses:{},
        VehicleTemplates:[],
        VehicleClass: [],
        NewVehicle: {
          branch_id:0,
          fleet_group_id:0,
          vrm: "",
          date_reg_uk: "",
          make: "",
          model: "",
          year: "",
          class: "",
          color: "",
          engine_number: "",
          fuel_type: "",
          drive_type: "",
          body_type: "",
          engine_capacity: "",
          transmission: "",
          vin: "",
          keepers: "",

          fleet_number: "",
          current_mileage: "",
          mot_due: "",
          tax_due: "",
          insurance_expiry: "",
          last_pmi_date: "",
          next_pmi_due: "",
          lastservice_mile: "",
          lastservice_date: "",
          nextservice_mile: "",
          nextservice_date: "",
          tracker_status: "No_Tracker",
          company_vehicle_type: "Fleet",
          fuel_status: "Fuel",
          tracker_company: "",
          inseego_node_id: null,
          contract_start_date: "",
          contract_end_date: "",
          fuel_card_number: "",

          vehicle_check_template_id: 0,
        },
        
        FuelTrackingModule: false,
        Drivers: [],
        AssginVehicle: { driver_id: 0, vehicle_id: 0 },

        NewDocument: {},
        DocumentModels: [],
        file: "",
        Groups:[],
        Services: [],
        Insurances: [],
        CheckFailures: [],
        VehicleNotes: "",
        ShowVehicleNotesModel: false,
        ShowVehicleNotesModelHeading: "Notes",     
        MileageUnit:'Mileage',
        AccountPermissions:[],     
        HGVClasses:["HGV","HCV"]   

      };
    },
    validations: {
      NewVehicle: {
        vrm: { required },
        date_reg_uk: { required },
        make: { required },
        model: { required },
        year: { required },
        class: { required },
        /*transmission: { required },
        keepers: { required },
        vin: { required },*/
      },
    },
    
    mounted() {
      //check account permission
    this.AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
      );
    this.FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );

    var FleetSubscriptionModules = JSON.parse(
      this.FleetSubscription.fleet_modules
    );
    
    
    this.FuelTrackingModule = FleetSubscriptionModules["Fuel Tracking"];

    if (this.AccountPermissions && 
      this.AccountPermissions.Documents &&
      this.AccountPermissions.Documents.enable) {
        this.ShowDocuments = true;
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowDocuments = true;
      }

      document.title = pbx_SiteTitle + " - Vehicle Edit";      
      this.VehicleId = this.$route.params.VehicleId;  
      this.GetGroups();    
      this.forceRerender();
      this.GetBranches();
      this.GetCompanySubscription();
      this.GetVehicleClasses();      
      var CompanyData = JSON.parse(localStorage.getItem("Company"));
      if(CompanyData && CompanyData.mileage_unit == 2){
        this.MileageUnit = 'KM';
      }
      setTimeout(() => {
        this.NewVehicle = this.VehicleDetails;
        if(this.NewVehicle.class == "HCV"){
          this.NewVehicle.class = "HGV"
        }
        if (this.VehicleClass.length > 0 && !this.VehicleClass.includes(this.NewVehicle.class)) {
          this.ShowClassTooltip = true;
        }
        this.GetVehicleCheckTemplates();
      }, 500);
    },
    watch: {
      "NewVehicle.current_mileage"() {
        this.mileageConfirmed = false;
        this.confirmedMileageValue = null;
      },
    },
    computed: {
    	origin() {
      		if (!this.start) return null;
      		return { query: this.start };
    	},
    	destionation() {
      		if (!this.end) return null;
      		return { query: this.end };
    	},    		
  	},
    methods: {
      checkNextPMI(){
        var obj = {
          token: localStorage.getItem("token"),
          date: this.NewVehicle.last_pmi_date,
        };
        Axios.post(Endpoints.Vehicle.CalculateNextPmi, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.NewVehicle.next_pmi_due = Response.data.date;
          }
        });
      },
      GetGroups() {
        var obj = {
          token: localStorage.getItem("token"),
        };
        Axios.post(Endpoints.Groups.List, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.Groups = Response.data.records;
          }
        });
      },
      EditDocument(document) {
        this.$parent.EditDocument(document);
      },
      DeleteDocument(document_id) {
        this.$parent.DeleteDocument(document_id);
      },
      ViewDocumentDetails(document){
        this.$refs.vehicle_document.ViewDetailDocument(document);
      },
      GetDocumentList (){
        this.$refs.vehicle_document.GetDocumentList();
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isTracking = FleetSubscriptionModules['Vehicle Tracking'];
        if (isTracking) {
          this.trackingModule = true;
        }
      },
      GetVehicleClasses(){
        if(localStorage.getItem("Classes")){
          this.VehicleClasses = JSON.parse(localStorage.getItem("Classes"));
        }else{
          var obj = { token: localStorage.getItem("token"), simple_list:true };
          Axios.post(Endpoints.VehicleChecks.GetVehicleClassList, obj).then((Response) => {
            if (Response?.data?.success) {
              this.VehicleClasses = Response.data.records;
              this.VehicleClasses.forEach((element) => {
                this.VehicleClass.push(element.title);
              })
              
            }
          });
        }
      },      
      GetVehicleCheckTemplates(){        
        var obj = { 
        	token: localStorage.getItem("token"),
        	vehicle_id: this.VehicleId,
	       	class: this.NewVehicle.class
	    };
        Axios.post(Endpoints.VehicleCheckTemplate.VehicleTemplates, obj).then((Response) => {
            if (Response?.data?.success) {
              this.VehicleTemplates = Response.data.Templates;              
            }
        });        
      },	
      GetBranches(){
        var obj = { token: localStorage.getItem("token"), select_branch: true };
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Branches = Response.data.records;
          }
        });
      },
      forceRerender() {
        this.componentKey += 1;
      },
      SetVehicleTrackerStatus(type) {
        this.NewVehicle.tracker_status = type;
      },
      SetVehicleType(type){
        this.NewVehicle.company_vehicle_type=type
      },
      SetVehicleRegistrationRegion(type){
        this.NewVehicle.registration_region=type
      },
      SetFuelStatus(type) {
        this.NewVehicle.fuel_status = type;
      },
      UpdateVehicle(type) {
        this.submitted = true;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        if (this.Saving) {
          return;
        }
        if(this.UKVDEditForm === true){
          this.UKVDSaveData = true;
        }else if(this.serviceEditForm === true){
          this.ServiceSaveData = true;
        }else{
          this.SaveData = true;
        }
        this.Saving = true;
        confirmMileageThen(
          this,
          {
            id: this.NewVehicle.id || this.VehicleId,
            vehicle_id: this.NewVehicle.id || this.VehicleId,
            vrm: this.NewVehicle.vrm,
            current_mileage: this.NewVehicle.current_mileage,
          },
          () => this.submitUpdateVehicle(type),
          () => {
            this.Saving = false;
            this.SaveData = false;
            this.ServiceSaveData = false;
            this.UKVDSaveData = false;
          }
        );
      },
      submitUpdateVehicle(type) {
        if(this.NewVehicle.tracker_status != "Tracker_Fitted"){
          this.NewVehicle.tracker_company = "";
          this.NewVehicle.contract_start_date = "";
          this.NewVehicle.contract_end_date = "";
        }
        Axios.post(Endpoints.Vehicle.Update, {
          token: localStorage.getItem("token"),
          ...this.NewVehicle,
          mileage_confirmed: this.mileageConfirmed ? 1 : 0,
        }).then((Response) => {
          this.Saving = false;
          this.SaveData = false;
          if (Response?.data?.warning) {
            this.ServiceSaveData = false;
            this.UKVDSaveData = false;
            confirmSuspiciousMileage(this, Response.data.message).then((confirmed) => {
              if (confirmed) {
                this.mileageConfirmed = true;
                this.confirmedMileageValue = this.NewVehicle.current_mileage;
                this.UpdateVehicle(type);
              }
            });
            return;
          }
          if (Response?.data?.success) {
            this.$emit("classUpdate");
            this.$swal
              .fire(type+" has been Updated Successfully", "", "success")
              .then(() => {
                if(this.UKVDEditForm === true){
                  this.CancelUKVDEditVehiclePage();
                }else if(this.serviceEditForm === true){
                  this.CancelServiceEditVehiclePage();
                }else{
                  this.CancelEditVehiclePage();
                }
              });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response?.data?.message || "Something went wrong",
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      EditVehiclePage() {
        this.editForm = true;
      },
      CancelEditVehiclePage() {
        this.SaveData = false;
        this.editForm = false;
        //this.GetVehicleDetail();
      },
      UKVDEditVehiclePage() {
        this.UKVDEditForm = true;
      },
      CancelUKVDEditVehiclePage() {
        this.UKVDSaveData = false;
        this.UKVDEditForm = false;
      },
      EditServiceVehiclePage() {
        this.serviceEditForm = true;
      },
      CancelServiceEditVehiclePage() {
        this.ServiceSaveData = false;
        this.serviceEditForm = false;
      },
      onSelectTrackerCompany() {
      	if(this.NewVehicle.tracker_company != 'Other'){
	      	this.$swal.fire({
	          title: "Fetching data ...",	          
	          text: "Please wait...",	          
	          showConfirmButton: false,
	          allowOutsideClick: false,
	        });
	        var obj = { 
	        	token: localStorage.getItem("token"), 
	        	vehicle_id: this.VehicleId,
	        	tracker_company: this.NewVehicle.tracker_company 
	    	};
	        Axios.post(Endpoints.Vehicle.GetInseegoData, obj).then((Response) => {
	          this.ShowLoader = false;
	          if (Response?.data?.success) {
	          	this.NewVehicle.inseego_node_id = Response.data.NodeId; 
	            this.$swal.fire(Response?.data?.message || "Something went wrong", "", "success");
	          }else{
	          	this.$swal.close();
	          }
	        });
	    }else{
	    	this.NewVehicle.inseego_node_id = null;
	    }    
      },   
      
      ViewDetailDocument(document) {
        this.ViewDocument = document;
        this.ShowViewDetailModel = true;
      },

      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },

      
      UpdateVehicleData(type) {
        this.submitted = true;
         this.SaveData = true;
        if (this.$refs.file && this.$refs.file.files[0]) {
          let formData = new FormData();
          formData.append('token', localStorage.getItem('token'));
          formData.append('file', this.file);
          formData.append('vrm', this.NewVehicle.vrm.toLowerCase());
          Axios.post(Endpoints.Vehicle.ImageUpload, formData).then((Response) => {
            this.submitted = false;
            if (Response.data.status == true) {
              //this.NewVehicle.image = Response.data.file;
              this.UpdateVehicle(type);
            } else {
              this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
            }
          });
        } else {
        this.UpdateVehicle(type);
        }
      },
   
    },
  }